module.exports = __webpack_public_path__ + "static/media/microcentrifuge_lid_open.4a170048.svg";